import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { CampaignsService } from '@pages/campaigns/campaigns.service';
import { IStats } from '@shared/interfaces/stats.interface';
import { EMPTY, MonoTypeOperatorFunction, Observable, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface ICampaignsKpiCardsState {
  stats: IStats[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: ICampaignsKpiCardsState = {
  error: null,
  loading: false,
  stats: null,
};

@Injectable()
export class CampaignsKpiCardsStore extends ComponentStore<ICampaignsKpiCardsState> {
  public readonly stats$ = this.selectSignal((state: ICampaignsKpiCardsState) => state.stats);
  public readonly loading$ = this.selectSignal((state: ICampaignsKpiCardsState) => state.loading);
  public readonly error$ = this.selectSignal((state: ICampaignsKpiCardsState) => state.error);

  private readonly handleError = (errorMessage: string): MonoTypeOperatorFunction<unknown> =>
    pipe(
      catchError(() => {
        this.patchState({
          error: errorMessage,
          loading: false,
        });

        return EMPTY;
      }),
    );

  public readonly fetchCampaignsStats = this.effect((trigger$: Observable<void>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap(() =>
        this.campaignsService.getCampaignsStats().pipe(
          tap((stats) => {
            this.patchState({ loading: false, stats });
          }),
          this.handleError('Failed to load creators'),
        ),
      ),
    );
  });

  constructor(private readonly campaignsService: CampaignsService) {
    super(initialState);
  }
}
